import{ApolloLink as e,fromPromise as o,toPromise as t,Observable as n}from"@apollo/client";const f=f=>new e((l,r)=>o(f().then(o=>t((o instanceof e?o:o.default).request(l,r)||n.of()))));export{f as lazy};
//# sourceMappingURL=index.modern.js.map
